import {
  DayAvailability,
  HourAvailability,
  TempDayAvailability,
  TempHourAvailability,
  TimeSlotAvailability,
} from '../types';
import { flattenTimeScheduel } from './WeeklySetting/WeekSetting';

export const checkForOverlapping = (
  hours: TempHourAvailability[],
): number[] => {
  const overLapIndex = new Set<number>([]);
  for (let i = 0; i < hours.length; i++) {
    for (let j = i + 1; j < hours.length; j++) {
      const start1 = hours[i].from.hour * 60 + hours[i].from.minute;
      const end1 = hours[i].to.hour * 60 + hours[i].to.minute;
      const start2 = hours[j].from.hour * 60 + hours[j].from.minute;
      const end2 = hours[j].to.hour * 60 + hours[j].to.minute;
      if (
        (start1 < start2 && start2 < end1) ||
        (start1 < end2 && end2 < end1) ||
        (start2 < start1 && start1 < end2) ||
        (start2 < end1 && end1 < end2)
      ) {
        overLapIndex.add(i);
        overLapIndex.add(j);
      }
    }
  }
  const res: number[] = [];
  overLapIndex.forEach((v) => res.push(v));
  return res;
};

export const getDisableEndTimes = (
  from: TimeSlotAvailability,
): {
  disabledHours: () => number[];
  disabledMinutes: (selectedHour: number) => number[];
} => {
  if (from.hour === null || from.minute === null) {
    return {
      disabledHours: () => [],
      disabledMinutes: () => [],
    };
  }
  const disabledHours = () => {
    const hours = [];
    for (let i = 0; i < from.hour; i++) {
      hours.push(i);
    }
    return hours;
  };
  const disabledMinutes = (selectedHour: number) => {
    const minutes = [];
    if (selectedHour === from.hour) {
      for (let i = 0; i < from.minute; i += 5) {
        minutes.push(i);
      }
    }
    return minutes;
  };
  return {
    disabledHours,
    disabledMinutes,
  };
};

export const getDisableStartTimes = (
  to: TimeSlotAvailability,
): {
  disabledHours: () => number[];
  disabledMinutes: (selectedHour: number) => number[];
} => {
  if (to.hour === null || to.minute === null) {
    return {
      disabledHours: () => [],
      disabledMinutes: () => [],
    };
  }
  const disabledHours = () => {
    const hours = [];
    for (let i = to.hour + 1; i < 24; i++) {
      hours.push(i);
    }
    return hours;
  };
  const disabledMinutes = (selectedHour: number) => {
    const minutes = [];
    if (selectedHour === to.hour) {
      for (let i = to.minute; i < 60; i += 5) {
        minutes.push(i);
      }
    }
    return minutes;
  };
  return {
    disabledHours,
    disabledMinutes,
  };
};

export const hasDataChanged = (
  initData: DayAvailability[],
  updatedData: TempDayAvailability[],
): boolean => {
  // data from api
  const initDataFlat = flattenTimeScheduel(
    JSON.parse(JSON.stringify(initData)),
  );
  const updatedDataFlat = JSON.parse(
    JSON.stringify(updatedData),
  ) as TempDayAvailability[];
  const weeklyData: DayAvailability[] = updatedDataFlat.map((day) => {
    return {
      days: day.days,
      hours: day.dayOff
        ? []
        : day.hours.filter(
            (hour) =>
              hour.from.hour !== null &&
              hour.to.hour !== null &&
              hour.from.minute !== null &&
              hour.to.minute !== null,
          ),
    };
  });
  if (initDataFlat) {
    let isDirty = false;
    for (let i = 0; i < 7; i++) {
      const originalDay = initDataFlat.find((day) => day.days.includes(i));
      const newDay = weeklyData.find((day) => day.days.includes(i));
      const originalHours = (originalDay?.hours || []).map(
        (hour) =>
          `${hour.from.hour * 60 + hour.from.minute}-${
            hour.to.hour * 60 + hour.to.minute
          }`,
      );
      const newHours = (newDay?.hours || []).map(
        (hour) =>
          `${hour.from.hour * 60 + hour.from.minute}-${
            hour.to.hour * 60 + hour.to.minute
          }`,
      );
      if (originalHours.length !== newHours.length) {
        isDirty = true;
        break;
      } else if (originalHours.some((hour) => !newHours.includes(hour))) {
        isDirty = true;
        break;
      }
    }
    return isDirty;
  }
  return false;
};
